import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import HistoryItemIcon from "../../../Custom-imeges/HistoryItemIcon";
import TrashIcon from "../../../Custom-imeges/TrashIcon";
import DeleteWorkflowRunModal from "./DeleteWorkflowRunModal";
import WorkflowFilter from "./WorkflowFilter";
import {
  getAllWorkflowRunParams,
  useDeleteAllWorkflowRuns,
  useDeleteworkflowRunById,
  useGetAllWorkflowRuns,
} from "../../../store/Apis/WorkflowsApi";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  WorkflowRunsType,
  setAllWorkflowRuns,
  setCurrentWorkflowRunData,
  setSelectedWorkflowRun,
} from "../../../store/one-query/workflowsSlice";
import { useNavigate } from "react-router-dom";
import useDebounce from "../../main-page/components/get-conversation/useDebounce";
import FilterIcon from "../../../Custom-imeges/Workflows-Icons/FilterIcon";
import { Dayjs } from "dayjs";
import { convertUtcToLocalMonthDateTime } from "../../../store/one-query/useMethodHelper";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { SharePopup } from "../../../shared/SharePopup";
import { ShareType } from "../../../Helper";
import { useCreateShareUrl } from "../../../store/Apis/ShareApi";

interface WorkflowHistoryProps {
  show: boolean;
  handleClose: () => void;
  setSelectedWorkflowRunId: (id: string) => void;
}
const WorkflowHistoryModal = ({
  show,
  handleClose,
  setSelectedWorkflowRunId,
}: WorkflowHistoryProps) => {
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [showDeleteAll, setShowDeleteAll] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [openCalendar, setOpenCalendar] = useState<boolean>(false);
  const debouncedSearchTerm = useDebounce(search, 1000);
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [toDate, setToDate] = useState<Dayjs | null>(null);
  const AllWorkflowRuns = useAppSelector((s) => s.workflows.allWorkflowRuns);
  const selectedWorkflowRun = useAppSelector(
    (s) => s.workflows.selectedWorkflowRun
  );
  const [workflowQueryParams, setWorkflowQueryParams] =
    useState<getAllWorkflowRunParams>({});
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const deleteAllWorkflowRuns = useDeleteAllWorkflowRuns();
  const deleteWorkflowRunBtId = useDeleteworkflowRunById();
  const { data: workflowData, isPending: isWorkflowHistoryLoading } =
    useGetAllWorkflowRuns(workflowQueryParams);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const { mutate: CreateShareUrl, data: sharingLinkData } = useCreateShareUrl();

  useEffect(() => {
    if (workflowData) dispatch(setAllWorkflowRuns(workflowData));
  }, [workflowData]);

  useEffect(() => {
    setWorkflowQueryParams({ Search: debouncedSearchTerm });
  }, [debouncedSearchTerm]);

  const handleDeleteSelectedWorflow = () => {
    setShowDelete(false);
    deleteWorkflowRunBtId(selectedWorkflowRun.id);
  };

  const handleDeleteAllWorflows = () => {
    deleteAllWorkflowRuns();
    setShowDeleteAll(false);
  };

  const handleWorkflowRunActive = (workflowRun: WorkflowRunsType) => {
    const currentWorkflowRunData = {
      runId: workflowRun.id,
    };
    setSelectedWorkflowRunId(workflowRun.id);
    navigate(`/workflows/${workflowRun.workflowId}`);
    dispatch(setCurrentWorkflowRunData(currentWorkflowRunData));
    handleClose();
  };

  const handleDeleteSelectedWorkflowRun = (
    e: React.MouseEvent<HTMLDivElement>,
    workflowRun: WorkflowRunsType
  ) => {
    e.stopPropagation();
    setShowDelete(true);
    dispatch(setSelectedWorkflowRun(workflowRun));
  };
  const FilterByDate = (fromDate: Dayjs | null, toDate: Dayjs | null) => {
    setWorkflowQueryParams({ FromDate: fromDate, ToDate: toDate });
    setIsFilter(true);
    setOpenCalendar(false);
  };
  const handleDateChange = (date: Dayjs | null, isFrom: boolean) => {
    if (isFrom) {
      setFromDate(date);
    } else {
      setToDate(date);
    }
  };
  const handleResetFilter = () => {
    setWorkflowQueryParams({});
    setIsFilter(false);
    setOpenCalendar(false);
    setFromDate(null);
    setToDate(null);
  };
  const closeFilter = () => {
    setOpenCalendar(false);
    setFromDate(null);
    setToDate(null);
  };

  const handleShowSharePopup = (
    e: React.MouseEvent<HTMLDivElement>,
    workflowRun: WorkflowRunsType
  ) => {
    e.stopPropagation();
    const RequestData = {
      shareType: ShareType.Workflow,
      shareId: workflowRun.id,
    };
    CreateShareUrl(RequestData);
    setShowSharePopup(true);
    dispatch(setSelectedWorkflowRun(workflowRun));
  };

  const handleCloseSharePopup = () => {
    setShowSharePopup(false);
  };

  return (
    <>
      <Modal
        className="DeleteModal workflowHistory"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton className="clearConPopupHeader border-0">
          <Modal.Title>History</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={`DeleteModalBody workflow-history-container border-0 rounded-bottom-4 px-0`}
        >
          <div className="d-flex flex-column align-items-start position-relative">
            <div className="d-flex align-items-center justify-content-center mb-1 py-1 w-100">
              <div
                className="searchBox search-workflow"
                style={{ zIndex: "100000" }}
              >
                <Form.Label
                  className="mb-0"
                  htmlFor="historySearch"
                  style={{ marginLeft: "5px" }}
                >
                  <img
                    className="search-icon"
                    src={"/images/GetConversations/search-normal.svg"}
                  />
                </Form.Label>
                <Form.Control
                  id="historySearch"
                  placeholder="Search"
                  value={search || ""}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span
                  className="workflow-filter-icon position-relative"
                  style={{
                    backgroundColor: openCalendar
                      ? "#76CFEB80"
                      : "var(--A_backgroundColor95)",
                  }}
                  onClick={() => setOpenCalendar(!openCalendar)}
                >
                  <FilterIcon className="custom-icon" />
                  {isFilter && <span className="circle-red"></span>}
                </span>
              </div>
            </div>
          </div>
          {openCalendar ? (
            <Box sx={{}}>
              <WorkflowFilter
                fromDate={fromDate}
                toDate={toDate}
                handleResetFilter={handleResetFilter}
                handleDateChange={handleDateChange}
                handleClose={closeFilter}
                method={FilterByDate}
              />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  minHeight: AllWorkflowRuns.length > 0 ? "410px" : "442px",
                  display:
                    !AllWorkflowRuns?.length || isWorkflowHistoryLoading
                      ? "flex"
                      : "",
                  alignItems:
                    !AllWorkflowRuns?.length || isWorkflowHistoryLoading
                      ? "center"
                      : "",
                  justifyContent: !AllWorkflowRuns?.length ? "center" : "",
                }}
              >
                {isWorkflowHistoryLoading ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress sx={{ color: "#12B6EA" }} />
                  </Box>
                ) : AllWorkflowRuns?.length > 0 ? (
                  <TableContainer
                    className="workflow-history-table"
                    sx={{
                      maxHeight: "350px",
                      scrollbarWidth: "none",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Table
                      sx={{
                        minWidth: 334,
                        color: "var(--Main_icons_color)",
                        margin: "8px",
                      }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" className="table-head">
                            Name
                          </TableCell>
                          <TableCell className="table-head">Date</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {AllWorkflowRuns?.map((workflowRun, i) => (
                          <TableRow
                            key={i}
                            className={`body-row ${
                              workflowRun?.id === selectedWorkflowRun?.id &&
                              "selected"
                            }`}
                            sx={{
                              padding: "12px",
                              margin: "8px",
                              borderRadius: "8px",
                            }}
                            onClick={() => handleWorkflowRunActive(workflowRun)}
                          >
                            <TableCell
                              className="body-cell"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <span className="me-2">
                                <HistoryItemIcon />
                              </span>
                              {workflowRun.name}
                            </TableCell>
                            <TableCell className="body-cell">
                              {convertUtcToLocalMonthDateTime(
                                workflowRun.createdAt
                              )}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              sx={{
                                padding: "14px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "1rem",
                                }}
                              >
                                <Box
                                  onClick={(e) =>
                                    handleShowSharePopup(e, workflowRun)
                                  }
                                >
                                  <ShareOutlinedIcon sx={{ width: "20px" }} />
                                </Box>
                                <Box
                                  onClick={(e) =>
                                    handleDeleteSelectedWorkflowRun(
                                      e,
                                      workflowRun
                                    )
                                  }
                                >
                                  <TrashIcon className="custom-icon" />
                                </Box>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <img alt="workflowLogo" className="workflow-logo" />
                    <Typography
                      className="mt-2 mb-2"
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "700",
                        fontSize: "18px",
                        lineHeight: "24px",
                        letterSpacing: "0.5px",
                        textAlign: "center",
                        color: "var(--Main_icons_color)",
                      }}
                    >
                      No Workflow found
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.4px",
                        color: "var(--Main_icons_color)",
                        opacity: "0.7",
                        textAlign: "center",
                      }}
                    >
                      Start to use our templets our create your own workflow
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {AllWorkflowRuns.length > 0 && (
                  <Typography
                    onClick={() => setShowDeleteAll(true)}
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: "500",
                      fontSize: "11px",
                      lineHeight: "16px",
                      letterSpacing: "0.5px",
                      color: "var(--M-background112)",
                      margin: "8px",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Clear All History
                  </Typography>
                )}
              </Box>
            </>
          )}
        </Modal.Body>
      </Modal>
      {showDelete && (
        <DeleteWorkflowRunModal
          show={showDelete}
          handleClose={() => setShowDelete(false)}
          message={`Are you sure to clear “${selectedWorkflowRun.name}”?`}
          method={handleDeleteSelectedWorflow}
        />
      )}
      {showDeleteAll && (
        <DeleteWorkflowRunModal
          show={showDeleteAll}
          handleClose={() => setShowDeleteAll(false)}
          message={`Are you sure to clear “All history”?`}
          method={handleDeleteAllWorflows}
        />
      )}
      {showSharePopup && (
        <SharePopup
          show={showSharePopup}
          handleClose={handleCloseSharePopup}
          sharingLink={sharingLinkData?.shareUrl || ""}
          title={`Sharing ${selectedWorkflowRun?.name || ""}`}
        />
      )}
    </>
  );
};

export default WorkflowHistoryModal;
